import { Calendar, Popover, PopoverContent, PopoverTrigger, TimeInput, Tooltip } from '@ds';
import { ZonedDateTime } from '@internationalized/date';
import { MdOutlineInfo } from 'react-icons/md';
import { DEFAULT_DATE_FORMAT_STRING } from '@/constants/date.constants';
import { formatDate, truncateToMinutes } from '@/utils/helpers';

type GoTimePickerProps = {
  dateTime: ZonedDateTime;
  setDateTime: (dt: ZonedDateTime) => void;
};

export const GoTimePicker = ({ dateTime, setDateTime }: GoTimePickerProps) => {
  return (
    <div className="flex items-center gap-2 text-m-r text-base-5">
      <span className="text-m-r text-base-5">Go time</span>
      <Popover placement="bottom">
        <PopoverTrigger>
          <div className="cursor-pointer underline">
            {formatDate(dateTime.toDate(), DEFAULT_DATE_FORMAT_STRING, { timezone: dateTime.timeZone })}
          </div>
        </PopoverTrigger>
        <PopoverContent className="p-0">
          <Calendar
            aria-label="Go date picker"
            value={dateTime}
            onChange={setDateTime}
            bottomContent={
              <div className="flex items-center gap-6 px-4 pt-1 pb-3">
                <span className="text-l-m">Time</span>
                <TimeInput
                  size="sm"
                  aria-label="Go time picker"
                  hourCycle={24}
                  value={dateTime}
                  onChange={(zdt) => zdt && setDateTime(truncateToMinutes(zdt))}
                />
              </div>
            }
          />
        </PopoverContent>
      </Popover>
      <Tooltip showArrow content="'Go Time' is the expected estimated departure time from CS's current location.">
        <div>
          <MdOutlineInfo size={20} />
        </div>
      </Tooltip>
    </div>
  );
};
